export default [
  {
    path: '/home',
    // Relative to /src/views
    view: 'Home'
  },
  {
    path: '',
    view: 'Home'
  },
  {
    path: '/contact',
    view: 'Contact'
  },
  {
    path: '/about',
    view: 'About'
  },
  {
    path: '/pricing',
    view: 'Pricing'
  },
  {
    path: '/cutsheets',
    view: 'CutSheets'
  },
  {
    path: '/beefform',
    view: 'BeefForm'
  }

]
